import { Injectable} from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import * as moment from 'moment';

@Injectable({
  providedIn: 'root'
})
export class ReportOptionsService {

  public vehicleName: string;
  public setName: string;
  public groupName: string;
  public typeName: string;
  public driverName: string;

  constructor(private translateService: TranslateService) { }

  combineStatusAndType(data) {
    if (data.type === 'Trasa') {
      return this.translateService.instant('reports.road') + ' ' + data.distance + 'km';
    }
  }

  formatTime(data, isString): string {
    let duringTime: any;
    if (isString && data) {
      if (data === '---') {
        return data;
      } else {
        const dataAboutTime = data.split(':');
        duringTime = moment.duration({
          // tslint:disable-next-line:radix
          hours: Number.parseInt(dataAboutTime[0]),
          // tslint:disable-next-line:radix
          minutes: Number.parseInt(dataAboutTime[1]),
          // tslint:disable-next-line:radix
          seconds: Number.parseInt(dataAboutTime[2]),
        });
      }
    } else {
      duringTime = moment.duration(data);
    }
    let dataString = '';
    if (duringTime.years() > 0) {
      dataString += duringTime.years() + this.translateService.instant('reports.container-life.years') + ' ';
    }
    if (duringTime.months() > 0) {
      dataString += duringTime.months() + this.translateService.instant('reports.container-life.months') + ' ';
    }
    if (duringTime.days() > 0) {
      dataString += duringTime.days() + this.translateService.instant('reports.container-life.days') + ' ';
    }
    if (duringTime.hours() > 0) {
      dataString += duringTime.hours() + this.translateService.instant('reports.container-life.hours') + ' ';
    }
    if (duringTime.minutes() > 0) {
      dataString += duringTime.minutes() + this.translateService.instant('reports.container-life.minutes') + ' ';
    }
    return dataString;
  }

}
